import en from './en/en.json';
import it from './it/it.json';

export default {
  en,
  it,
};
